
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 440 440","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M248.503 80c3.459 0 6.738 1.398 9.257 3.844 2.38 2.442 3.773 5.721 3.773 9.163v71.082c1.3-.42 2.656-.64 4.018-.64h57.066c3.497 0 6.78 1.371 9.186 3.773.048.047.082.085.114.127l.11.155-.023-.021c2.312 2.442 3.643 5.592 3.643 8.913V319.6h23.937c2.454 0 4.416 1.981 4.416 4.47v31.398c0 2.495-1.967 4.531-4.416 4.531H80.476c-2.454 0-4.476-2.042-4.476-4.53v-31.398a4.472 4.472 0 014.476-4.471h23.937v-94.617c0-3.342 1.302-6.563 3.523-8.853l.512-.512c2.389-2.316 5.567-3.642 8.935-3.642h57.066c1.354 0 2.708.246 4.018.71V93.007c0-3.517 1.393-6.795 3.854-9.184l.31-.301h.062c2.389-2.229 5.534-3.522 8.804-3.522h57.006zm7.487 248.483H84.953v22.515h270.094v-22.515h-23.376l-.06.06h-75.62v-.06zm-81.54-107.504h-57.067l-.253.008a4.126 4.126 0 00-2.087.712l-.199.145-.273.291-.172.193c-.607.716-.97 1.557-1.026 2.42l-.007.236v94.617h65.101v-94.676l-.007-.232c-.055-.843-.406-1.64-1.005-2.344l-.17-.19-.12-.118-.164-.155c-.674-.594-1.54-.907-2.552-.907zm148.167-48.588H265.55l-.235.007c-.939.06-1.863.471-2.577 1.089a4.605 4.605 0 00-1.188 2.613l-.018.236V319.6h65.161V176.396l-.008-.234a4.248 4.248 0 00-.852-2.229l-.15-.183-.068-.046-.163-.133-.162-.152a4.11 4.11 0 00-2.674-1.028zm-74.114-83.449h-57.006l-.24.006c-1.031.055-1.923.46-2.596 1.175-.742.74-1.172 1.645-1.234 2.635l-.008.249V319.6h65.162V93.007l-.008-.247c-.06-.984-.481-1.899-1.174-2.637a3.974 3.974 0 00-2.637-1.174l-.26-.007z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    